export function match(param) {
	return param === 'preview';
}
